export enum InformacoesAeracaoVisaoColunasEnum {
    ID = 'id',
    CMD = 'cmd',
    RTN = 'rtn',
    PNL = 'pnl',
    IN_A = 'in_a',
    P_CV = 'p_cv',
    STATUS = 'status',
}
